import apiClient from "./client";
import { UserSettings } from "../types";

export interface UpdateSettingsRequest {
  llm_provider?: string;
  model_name?: string;
  api_key?: string;
}

export interface TestConnectionRequest {
  provider: string;
  api_key: string;
  model_name?: string;
}

const settingsApi = {
  getSettings: async (): Promise<UserSettings> => {
    const response = await apiClient.get<UserSettings>("/settings");
    return response.data;
  },

  updateSettings: async (
    data: UpdateSettingsRequest
  ): Promise<UserSettings> => {
    const response = await apiClient.post<UserSettings>("/settings", data);
    return response.data;
  },

  deleteApiKey: async (): Promise<void> => {
    await apiClient.delete("/settings/api-key");
  },

  testConnection: async (
    data: TestConnectionRequest
  ): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.post("/settings/test-connection", data);
    return response.data;
  },
};

export default settingsApi;
